module.exports = __webpack_public_path__ + "static/media/js.63cf9c6f.png";